module.exports = __webpack_public_path__ + "img/tc-16.1a8460f5.png";